document.addEventListener('DOMContentLoaded', ()=> {
    var mySwiper = new Swiper('.swiper-container.subcategory-list-grid', {  
        slidesPerView: 3.5,  
        grabCursor: true,  
        freeMode: true,  

        breakpoints: {  
            640: { // When viewport is 640px or smaller  
                slidesPerView: 3.5,  
            },  
            768: { // When viewport is 768px or smaller  
                slidesPerView: 5.5, // Set this to a number if you want specific counts  
            },  
            1024: { // When viewport is 768px or smaller  
                slidesPerView: 7, // Set this to a number if you want specific counts  
            },  
            1400: { // When the viewport is 1024px or larger
                slidesPerView: 8.5,  
            }  
        },
        loop: false, 
         
    });
})


